import { GlobalStore } from "./StoreProvider";

/** Load the current users active periculum office */
export const periculumOfficeSelector = (state: GlobalStore) =>
  state.profile.periculumOffice;

/** Load the current users profile */
export const profileSelector = (state: GlobalStore) => state.profile;
